import { call, put, takeLatest, select } from 'redux-saga/effects';

import {
    getSelfDataSuccess,
    getSelfDataFail,
    getReportDataSuccess,
    getReportDataFail,
    getUserAttemptsSuccess,
    getUserAttemptsFail
} from "./action";

import {
    GET_SELF_DATA_REQUEST,
    GET_REPORT_DATA_REQUEST,
    GET_USER_ATTEMPTS_REQUEST
} from "./constants";

import request from 'utils/request';
import { BASE_API_URL } from 'constants/api';
import { selectSelfDataList } from './selector';

function* getSelfDataRequest(action) {
    try {
        const API_USER_ATTEMPT_PATH = "/user/attempt?userAttemptId="
        const config_user_info = {
            method: 'get',
            url: `${BASE_API_URL}${API_USER_ATTEMPT_PATH}${action.payload.vr_app_session}`,
        };
        let response = yield call(request, config_user_info);
        
        yield put(getSelfDataSuccess(response));
        
        // After getting self data, fetch report data
        yield put(getReportDataRequest({
            userId: response.attemptResult.user.id,
            trainingId: response.training.id,
        }));
    } catch (err) {
        yield put(getSelfDataFail(err));
    }
}

function* getReportDataRequest(action) {
    try {
        const { userId, trainingId, startDate, endDate, aggregationType, currentUserId } = action.payload;

        const aUserId = currentUserId || userId;

        if (!aUserId) {
            yield put(getReportDataFail("User ID is required")); 
            return;
        }

        const response = yield call(request, {
            method: 'get',
            url: `${BASE_API_URL}/training/report`,
            params: {
                userId: aUserId || undefined,
                trainingId: trainingId || undefined,
                startDate: startDate || undefined,
                endDate: endDate || undefined,
                aggregationType: aggregationType || 0,
            },
        });
        
        yield put(getReportDataSuccess(response.reportItems));
    } catch (err) {
        yield put(getReportDataFail(err));
    }
}

function* getUserAttemptsRequest(action) {
    try {
        const { trainingId, userId } = action.payload;
        const response = yield call(request, {
            method: 'get',
            url: `${BASE_API_URL}/training/${trainingId}/user/${userId}/attempts`,
        });
        yield put(getUserAttemptsSuccess(response));
    } catch (err) {
        yield put(getUserAttemptsFail(err));
    }
}

export default function* hazmatSaga() {
    yield takeLatest(GET_SELF_DATA_REQUEST, getSelfDataRequest);
    yield takeLatest(GET_REPORT_DATA_REQUEST, getReportDataRequest);
    yield takeLatest(GET_USER_ATTEMPTS_REQUEST, getUserAttemptsRequest);
}
